import * as styled from './styles';

export const PublicTopBar = () => (
  <styled.TopBar>
    <styled.TopBarInner>
      <styled.Logo href="/">
        <styled.LogoMark>K</styled.LogoMark>
        <styled.LogoWordmark>kudable</styled.LogoWordmark>
      </styled.Logo>
      <styled.PromoCta href="/">✨ Get your own profile</styled.PromoCta>
    </styled.TopBarInner>
  </styled.TopBar>
);
